import pdfMake from 'addthaifont-pdfmake';
import 'addthaifont-pdfmake/build/vfs_fonts';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import { ClassNames } from '@emotion/react';
// import { text } from 'stream/consumers';

import { ReportHeader } from './common';

pdfMake.fonts = {
  Sarabun: {
    normal: 'Sarabun-Light.ttf',
    bold: 'Sarabun-Regular.ttf',
    italics: 'Sarabun-LightItalic.ttf',
    bolditalics: 'Sarabun-Italic.ttf',
  },
};
dayjs.locale('th');
dayjs.extend(buddhistEra);
dayjs.extend(LocalizedFormat);

const EmployeeSalaryReport = async (data, information, me) => {
  // console.log('data', data);
  console.log('information', information);
  console.log('Position', data?.user?.position?.name);
  console.log('data', data);
  console.log('ฝ่าย', data?.user?.group?.name);
  console.log('Department', data?.user?.department?.name);

  const countTaxSSO = () => {
    const sso = data.salary * (data?.taxSSO / 100);
    if (data?.salary >= 15000) {
      return 15000 * (data?.taxSSO / 100);
    }
    return sso;
  };

  const date = new Date();

  const formattedDate = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);

  const yearRevenue = () =>
    data?.allSalary?.allsalary -
    data?.allSalary?.sumSSO -
    data?.allSalary?.sumEtc;
  const revenue = () => data?.salary + data?.ot + data?.extra + data?.allowance;
  const expenses = () => {
    const sso = countTaxSSO();
    return sso + data?.tax + data?.etc;
  };
  const sumSalary = () => revenue() - expenses();
  const netIncome = () => {
    const sso = countTaxSSO();
    return data?.sumSalary - (sso + data?.tax + data?.etc);
  };
  const documentRef = {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [20, 320, 20, 20],
    defaultStyle: {
      font: 'Sarabun',
      fontSize: '8',
    },

    info: {
      title: `สลิปเงินเดือน_${data?.user?.name}_${dayjs(data?.date).format(
        'MMMM_BBBB'
      )}`,
    },
    header: [
      ReportHeader(information),
      {
        alignment: 'center',
        margin: [20, 0, 0, 0],
        table: {
          // headers are automatically repeated if the table spans over multiple pages
          // you can declare how many rows should be treated as headers
          // headerRows: 1,
          widths: ['70%', '*'],

          body: [
            [
              {
                text:
                  information?.name ||
                  'บริษัท พีเอสยู อินโนเวทีฟ เอ็นจิเนียริ่ง จำกัด',
                style: 'body2',
                border: [false, false, false, false],
              },

              {
                text:
                  'เดือน-ปี \t' + `${dayjs(data?.date).format('MMMM-BBBB')}`,
                style: 'body2',
                border: [false, false, false, false],
              },
            ],
            [
              { text: '', border: [false, false, false, false] },

              {
                text:
                  'M-Y-P   \t' +
                  `${dayjs(data?.date).locale('en').format('MMMM-YYYY')}`,
                style: 'body2',
                border: [false, false, false, false],
              },
            ],
          ],
        },
      },
      {
        margin: [20, 0, 0, 40],
        table: {
          // headers are automatically repeated if the table spans over multiple pages
          // you can declare how many rows should be treated as headers
          // headerRows: 1,
          widths: ['20%', '30%', '15%', '35%'],

          body: [
            [
              {
                text: 'ชื่อ-สกุล/Name',
                style: 'body2',
                border: [false, false, false, false],
              },
              {
                text: `${data?.user?.name}  ${data?.user?.surname || ' - '}`,
                style: 'body4',
                border: [false, false, false, false],
              },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
            ],

            [
              {
                text: 'ตำแหน่ง/Position',
                style: 'body2',
                border: [false, false, false, false],
              },
              {
                text: `${data?.user?.position?.name || '-'} `,
                border: [false, false, false, false],
                style: 'body4',
              },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
            ],
            [
              {
                text: 'วันที่จ่าย/Paid Date',
                style: 'body2',
                border: [false, false, false, false],
              },
              {
                text: `${dayjs(data?.datePay).format('DD MMMM BBBB') || '-'}`,
                style: 'body4',
                border: [false, false, false, false],
              },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
            ],
          ],
        },
      },
    ],
    content: [
      {
        margin: [0, -100, 0, 20],
        table: {
          heights: [15],
          headerRows: 1,
          widths: ['25%', '25%', '25%', '25%'],
          body: [
            [
              {
                text: 'รายได้/Income',
                colSpan: 2,
                style: 'body',
                fillColor: '#d2d4d2',
                border: [true, true, true, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              '',
              {
                text: 'รายการหัก/Deduction',
                colSpan: 2,
                style: 'body',
                fillColor: '#d2d4d2',
                border: [true, true, true, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              '',
            ],
            [
              {
                text: 'เงินเดือน/Salary',
                style: 'body6',
                border: [true, true, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: `${
                  data?.salary
                    ?.toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,') || '-'
                }`,
                style: 'body5',
                border: [false, true, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: 'ภาษีหัก ณ ที่จ่าย',
                style: 'body6',
                border: [true, true, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '0.00',
                style: 'body5',
                border: [false, true, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
            ],
            [
              {
                text: 'ค่าแรงวันหยุด',
                style: 'body6',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: `${
                  data?.ot?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') ||
                  '-'
                }`,
                style: 'body5',
                border: [false, false, true, false],
                fillColor: '#E0E0E0',
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: 'ประกันสังคม',
                style: 'body6',
                border: [true, false, false, false],
                fillColor: '#E0E0E0',
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: `${
                  countTaxSSO()
                    ?.toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,') || '0.00'
                }`,
                style: 'body5',
                border: [false, false, true, false],
                fillColor: '#E0E0E0',
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
            ],
            [
              {
                text: 'ค่าเบี้ยเลี้ยง',
                style: 'body6',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: `${
                  data?.allowance
                    ?.toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,') || '-'
                }`,
                style: 'body5',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: 'รายการหักอื่นๆ',
                style: 'body6',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: `${
                  data?.etc?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') ||
                  '-'
                }`,
                style: 'body5',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
            ],
            [
              {
                text: 'เงินพิเศษอื่นๆ',
                style: 'body6',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: `${
                  data?.extra?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') ||
                  '0.00'
                }`,
                style: 'body5',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: '',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: '',
                style: 'body1',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
            ],
            [
              {
                text: '      ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                heights: 8,
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '        ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
            ],
            [
              {
                text: '      ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                heights: 8,
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
            ],
            [
              {
                text: '      ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                heights: 8,
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '        ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
            ],
            [
              {
                text: '      ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                heights: 8,
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
            ],
            [
              {
                text: '      ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                heights: 8,
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '        ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
            ],
            [
              {
                text: '      ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                heights: 8,
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
            ],
            [
              {
                text: '      ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                heights: 8,
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '        ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
            ],
            [
              {
                text: '      ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                heights: 8,
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
            ],
            [
              {
                text: '      ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                heights: 8,
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '        ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
            ],
            [
              {
                text: '      ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                heights: 8,
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
            ],
            [
              {
                text: '      ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                heights: 8,
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '        ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
            ],
            [
              {
                text: '      ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                heights: 8,
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#E0E0E0',
              },
            ],
            [
              {
                text: '      ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                heights: 8,
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '        ',
                style: 'body2',
                border: [true, false, false, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '        ',
                style: 'body2',
                border: [false, false, true, false],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
            ],

            [
              {
                text: 'รวมรายได้/Total Income',
                fontSize: 10,
                border: [true, true, false, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#d2d4d2',
              },
              {
                text: `${
                  revenue()
                    ?.toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,') ||
                  revenue()
                    ?.toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                }`,
                fontSize: 10,
                alignment: 'right',
                border: [false, true, true, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#d2d4d2',
              },
              {
                text: 'รวมเงินหัก/Total Deduction',
                fontSize: 10,
                border: [true, true, false, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#d2d4d2',
              },
              {
                text: expenses()
                  ?.toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                fontSize: 10,
                alignment: 'right',
                border: [false, true, true, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#d2d4d2',
              },
            ],
            [
              {
                text: '',
                style: 'body2',
                border: [true, true, false, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: '',
                style: 'body2',
                border: [false, true, true, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
              {
                text: 'เงินได้สุทธิ/Net Income',
                fontSize: 10,

                border: [true, true, false, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#d2d4d2',
              },
              {
                text: sumSalary()
                  ?.toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                fontSize: 10,
                alignment: 'right',
                border: [false, true, true, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                fillColor: '#d2d4d2',
              },
            ],
          ],
        },
      },
      {
        margin: [0, -20, 0, 0],
        table: {
          headerRows: 1,
          widths: ['15%', '35%', '15%', '35%'],
          body: [
            [
              {
                text: 'ลงชื่อผู้จ่าย',
                border: [true, false, true, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                style: 'body',
              },
              {
                text: '',
                style: '',
                border: [true, false, true, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },

              {
                text: 'ลงชื่อผู้รับเงิน',
                border: [true, false, true, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                style: 'body',
              },
              {
                text: '',
                style: '',
                border: [true, false, true, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
            ],
            [
              {
                text: 'วันที่',
                border: [true, true, true, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                style: 'body',
              },
              {
                text: '',
                style: '',
                border: [true, true, true, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },

              {
                text: 'วันที่',
                border: [true, true, true, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
                style: 'body',
              },
              {
                text: '',
                style: '',
                border: [true, true, true, true],
                borderColor: ['#9ca3af', '#9ca3af', '#9ca3af', '#9ca3af'],
              },
            ],
          ],
        },
      },
    ],

    footer: [],

    styles: {
      header: {
        fontSize: 16,
        bold: true,
        alignment: 'center',
      },
      body: {
        fontSize: 10,
        bold: true,
        alignment: 'center',
      },
      body1: {
        fontSize: 10,
        bold: true,
        alignment: 'right',
      },
      body2: {
        fontSize: 10,
        bold: true,
        alignment: 'left',
      },

      body3: {
        fontSize: 12,
        bold: true,
        alignment: 'right',
        decoration: 'underline',
        decorationStyle: 'double',
      },
      body4: {
        fontSize: 10,
        bold: false,
        alignment: 'left',
      },
      body5: {
        fontSize: 10,
        bold: false,
        alignment: 'right',
      },
      body6: {
        fontSize: 10,
        bold: false,
        alignment: 'left',
      },

      footTb: {
        fontSize: 10,
        bold: true,
        alignment: 'right',
        alignment: 'center',
      },
      tab: {
        color: 'white',
      },
    },
    images: {
      logo: information?.image?.url,
      // sign: me?.userData?.signature?.url,
    },
  };

  pdfMake.createPdf(documentRef).open();
};
export default EmployeeSalaryReport;
